import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import * as BeMaccaferriStoreHelper from '../../../api/store/BeMaccaferriStoreHelper';
import { endpoint } from '../../../pages';
import { DataRow } from '../Table/ITable';
import Table from '../Table/Table';

interface IPanelMaterialProps {}

const PanelMaterial = (props: IPanelMaterialProps) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [materials, setMaterials] = useState<DataRow[]>([]);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [perPage, setPerPage] = useState(10);

    const setMaterialDataRowAsync = useCallback(async (page?: number, newPerPage?: number, name?: string) => {
        let materialResponse = await BeMaccaferriStoreHelper.getAllBaseMaterialAsync(page, newPerPage, name);
        let materialDataRow: DataRow[] = materialResponse.data.data.map(mat => ({ id: mat.id, name: mat.name, creationDate: mat.creationDate }));
        setMaterials(materialDataRow);
        setTotalRows(materialResponse.data.pagesCount * perPage);
    }, []);

    const fetchMaterials = async (page: number) => {
        setLoading(true);
        setMaterialDataRowAsync(page, perPage);
        setLoading(false);
    };

    const handlePageChange = (page: number) => {
        fetchMaterials(page);
    };

    const handlePerRowsChange = async (newPerPage: number, page: number) => {
        setLoading(true);
        setMaterialDataRowAsync(page, newPerPage);
        setPerPage(newPerPage);
        setLoading(false);
    };

    useEffect(() => {
        fetchMaterials(1);
    }, []);

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        setMaterialDataRowAsync(1, perPage, e.target.value);
    };

    const handleNew = () => {
        navigate(endpoint.backofficeMaterial);
    };

    return (
        <div className='panel-container'>
            <div className='nosubmit d-flex justify-content-between mb-4'>
                <input className='nosubmit' type='search' placeholder='Search...' onChange={handleSearch} />
                <button type='button' onClick={handleNew}>
                    {t('New Material')}
                </button>
            </div>

            <Table data={materials} progressPending={loading} pagination paginationServer paginationTotalRows={totalRows} onChangeRowsPerPage={handlePerRowsChange} onChangePage={handlePageChange} />
        </div>
    );
};

export default PanelMaterial;
